import request from '@/utils/request'

// 查询型号信息列表分页
export function fetchList(query) {
    return request({
        url: '/fix/model/page',
        method: 'get',
        params: query,
    })
}
// 查询筛选使用
export function publicModel(query) {
    return request({
        url: '/fix/model/public/page',
        method: 'get',
        params: query,
    })
}
// 查询筛选使用
export function publicTant(query) {
    return request({
        url: '/system/tenant/public',
        method: 'get',
        params: query,
    })
}
// 查询筛选使用
export function manyfile(query) {
    return request({
        url: '/fix/order/report/many/file',
        method: 'get',
        params: query,
    })
}
// 查询公司默认显示产品型号列表
export function tenantList(query) {
    return request({
        url: '/fix/model/default/tenant/list',
        method: 'get',
        params: query,
    })
}
// 设备参数
export function pressureDev(query) {
    return request({
        url: '/fix/dev/pressure/page',
        method: 'get',
        params: query,
    })
}
// 查询型号详细
export function getObj(id) {
    return request({
        url: '/fix/model/detail?id=' + id,
        method: 'get',
    })
}
// 新增型号
export function addObj(data) {
    return request({
        url: '/fix/model/add',
        method: 'post',
        data: data,
    })
}
// 设置公司默认显示产品型号
export function addModel(data) {
    return request({
        url: '/fix/model/default/tenant/add',
        method: 'post',
        data: data,
    })
}
// 修改型号
export function putObj(data) {
    return request({
        url: '/fix/model/edit',
        method: 'post',
        data: data,
    })
}
// 删除型号
export function delObj(data) {
    return request({
        url: '/fix/model/delete',
        method: 'post',
        data: data,
    })
}
// 禁用型号
export function statusObj(data) {
    return request({
        url: '/fix/model/status',
        method: 'get',
        params: data,
    })
}